module.exports = __webpack_public_path__ + "static/municipio.8a4bfa61.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/municipio.png
// module id = 1618
// module chunks = 35783957827783